import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef } from 'react';
import componentsUtils from '@common/utils/componentUtils';
import useMediaQueries from '@stone/hooks/useMediaQueries';
const TickerBar = (props) => {
    const ticker = useRef();
    const { t } = useTranslation();
    const { isMobile } = useMediaQueries();
    useEffect(() => {
        if (ticker && ticker.current) {
            componentsUtils.loadAsyncComponent(ticker.current);
            document.querySelector('body').classList.add('has-ticker');
        }
    }, [ticker.current]);
    const renderSlides = () => {
        return props.tickerSlides.map((slide, i) => (React.createElement("div", { className: "swiper-slide", key: i, "data-bgcolor": slide.bgcolor, "data-color": slide.textcolor },
            React.createElement("div", { className: "message-wrapper" }, slide.textm ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "message", dangerouslySetInnerHTML: { __html: isMobile ? slide.textm : slide.text } }))) : (React.createElement("div", { className: "message", dangerouslySetInnerHTML: { __html: slide.text } }))))));
    };
    if (!props.tickerSlides) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "ticker-bar", "data-component": "headerTickerComponent", ref: ticker, "data-option-prevslidemessage": t('carousel.prevslidemessage', 'carousel'), "data-option-nextslidemessage": t('carousel.nextslidemessage', 'carousel'), "data-option-firstslidemessage": t('carousel.firstslidemessage', 'carousel'), "data-option-lastslidemessage": t('carousel.lastslidemessage', 'carousel'), "data-option-paginationbulletmessage": t('carousel.paginationbulletmessage', 'carousel'), style: { '--ticker-color': '#FFFFFF', '--ticker-bgcolor': '#000000;' } },
        props.tickerSlides.length >= 2 ? (React.createElement("div", { className: "swiper-container" },
            React.createElement("div", { className: "swiper-wrapper" }, renderSlides()),
            React.createElement("button", { className: "swiper-button-prev", "aria-label": t('carousel.prevslidemessage', 'carousel') }),
            React.createElement("span", { className: "a11n-fix--prev" }),
            React.createElement("button", { className: "swiper-button-next", "aria-label": t('carousel.nextslidemessage', 'carousel') }),
            React.createElement("span", { className: "a11n-fix--next" }))) : (renderSlides()),
        React.createElement("button", { type: "button", className: "icon--close-white", "aria-label": t('button.close') }),
        React.createElement("span", { className: "a11n-fix--close" })));
};
export default TickerBar;
